import { Icon } from '@iconify/react';
import React from 'react';
import '../../../dist/assets/stylesheets/css/recordPatient.css';
import { Link } from 'react-router-dom';
import GreyButton from '../GreyButton';

function CalibrationSelection(props) {
    const generateColor = (status) => {
        let color;
        switch (status) {
            case 'success':
                color = '#9FD06A';
                break;
            case 'ready':
                color = '#E7D859';
                break;
            case 'failed':
                color = '#DD6364';
                break;
            case 'weak':
                color = '#FFA500';
                break;
            case 'uploading':
                color = '#92CEFA';
                break;
            default:
                color = '#BDBDBD';
        }
        return color;
    };

    const dataUnset = props.data == null;
    const rows = Array.isArray(props.data) ? props.data : [];

    return (
        <div className="table-container calibration-selection">
            <table>
                <thead>
                    <tr>
                        <th>Calib ID</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                    <tr>
                        <th colSpan="4">
                            <Link to="/calibration" style={{ display: 'block', width: '100%' }}>
                                <GreyButton title="Add new calibration" width="100%" />
                            </Link>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {dataUnset ? (
                        <tr>
                            <td colSpan={4} style={{ textAlign: 'center', color: '#666', padding: '16px' }}>
                                Loading calibrations…
                            </td>
                        </tr>
                    ) : rows.length === 0 ? (
                        <tr>
                            <td colSpan={4} style={{ textAlign: 'center', color: '#666', padding: '16px' }}>
                                No calibrations found.
                            </td>
                        </tr>
                    ) : (
                        rows.map((el) => {
                            const nameStr = el.name != null ? String(el.name) : '';
                            const datePart =
                                nameStr.split(' ').length > 1
                                    ? nameStr.split(' ').slice(1).join(' ')
                                    : nameStr;
                            return (
                                <tr
                                    key={el.id}
                                    className={props.selected == el.id ? 'selected' : ''}
                                    onClick={() => {
                                        props.selectCalibration(el.id);
                                    }}
                                >
                                    <td>{el.id}</td>
                                    <td>{datePart}</td>
                                    <td>
                                        <span
                                            style={{
                                                height: '10px',
                                                width: '10px',
                                                backgroundColor: generateColor(el.status),
                                                borderRadius: '50%',
                                                display: 'inline-block',
                                                marginRight: '3px',
                                            }}
                                        />
                                        {el.status}
                                    </td>
                                    <td className="action">
                                        {(el.status == 'success' ||
                                            el.status == 'ready' ||
                                            el.status == 'weak') && (
                                            <span
                                                className="svg-btn view-btn"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    props.selectCalibrationView(el.id);
                                                }}
                                            >
                                                <Icon icon="fluent:eye-24-regular" />
                                                View
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default CalibrationSelection;
